/**
 * Two-way part 2 (#1842): what the asker sees about their "Done looks like"
 * line once a task comes back — a green tick when the doer ticked it, an
 * amber ring when they handed it back without ticking (an honest "partly").
 * Colour and icon carry the meaning; the words are the asker's own line.
 */
import { CheckCircle2, CircleDashed } from "lucide-react";
import { cn } from "@/lib/utils";

export function DoneLooksLikeResult({ line, met, who }: { line: string; met: boolean; who: string }) {
    return (
        <div
            data-testid="dll-result"
            data-met={met ? "yes" : "no"}
            className={cn(
                "flex items-start gap-2 rounded-lg px-3 py-2 text-sm",
                met
                    ? "bg-emerald-100 text-emerald-950 dark:bg-emerald-900/60 dark:text-emerald-100"
                    : "bg-amber-100 text-amber-950 dark:bg-amber-950 dark:text-amber-100",
            )}
        >
            {met ? (
                <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" aria-label="Ticked" />
            ) : (
                <CircleDashed className="mt-0.5 h-4 w-4 shrink-0" aria-label="Not ticked" />
            )}
            <span>
                <span className="font-semibold">{met ? `${who} ticked: ` : `${who} did not tick: `}</span>
                {line}
            </span>
        </div>
    );
}
